/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import api from 'api';
import { Header, SideMenu } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea } from './styles';
import { loadingColor, primary } from 'styles/colorProvider';
import moment from 'moment';
import { BsFileEarmarkPdf } from 'react-icons/bs';

const dataColumns = [
  {
    name: 'Vigência Início',
    selector: (row) => moment(row?.start_date).format('DD/MM/YYYY'),
    width: '20%',
  },
  {
    name: 'Vigência Fim',
    selector: (row) => moment(row?.end_date).format('DD/MM/YYYY'),
    width: '20%',
  },
  {
    name: 'ID Externo',
    selector: (row) => row?.external_id,
    width: '30%',
  },
  {
    name: 'Apólice',
    selector: (row) => (
      <a href={row?.url_apolice} target="_blank" rel="noopener noreferrer">
        <BsFileEarmarkPdf size="18" style={{ marginRight: 6 }} />
        Abrir PDF
      </a>
    ),
    width: '30%',
  },
];

function ListApolicePolicy({ location }) {
  const policyId = parseInt(location.pathname.split('/backoffice/listar-apolices-contrato/')[1]);
  const [loading, setLoading] = useState(false);
  const [apoliceList, setApoliceList] = useState([]);

  const loadData = async () => {
    setLoading(true);
    try {
      const resp = await api({
        method: 'GET',
        url: `/splitrisk-policy/${policyId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        json: true,
      });
      setApoliceList(resp?.data?.TB_POLICY_SPLITRISK_DOCUMENTS || []);
    } catch (e) {
      setApoliceList([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <Header />
      <Container>
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>APÓLICES DO CONTRATO</Title>
          </Div>
          <DataArea>
            <DataTable
              persistTableHead
              responsive
              columns={dataColumns}
              data={apoliceList}
              highlightOnHover
              fixedHeader
              fixedHeaderScrollHeight="100%"
              progressPending={loading}
              progressComponent={
                <LoadingArea>
                  <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                </LoadingArea>
              }
              noDataComponent={<small style={{ marginTop: 20 }}>Nenhuma apólice recebida</small>}
            />
          </DataArea>
          <CountArea>
            {!loading && (
              <p style={{ color: primary }}>
                {apoliceList.length} registro(s) encontrado(s)
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default ListApolicePolicy;
